import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { ScrollTagModel, Tag } from './tag-scroll.model';

@Component({
  selector: 'oir-tag-scroll',
  templateUrl: './tag-scroll.component.html',
  styleUrls: ['./tag-scroll.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScrollTagsComponent implements DoCheck {

  @Output() readonly deleteTag: EventEmitter<Tag> = new EventEmitter();

  @Input() model: ScrollTagModel;
  @Input() readonly = false;

  @ViewChild('tagScrollBody') tagScrollBody: ElementRef;

  constructor(readonly elementRef: ElementRef,
              readonly cd: ChangeDetectorRef) {
  }

  ngDoCheck() {
    this.cd.detectChanges();
    if (this.model) {
      this.checkArrowVisibility();
    }
  }

  checkArrowVisibility(newScrollWidth?: number): void {
    const rightArrow = this.elementRef.nativeElement.getElementsByClassName('right')[0];
    const scrollWidth = newScrollWidth || this.tagScrollBody.nativeElement.scrollWidth;
    if (rightArrow) {
      if (scrollWidth > this.tagScrollBody.nativeElement.clientWidth) {
        rightArrow.classList.remove('hidden');
        rightArrow.classList.add('visible');
      } else {
        rightArrow.classList.remove('visible');
      }
    }
    this.cd.detectChanges();
  }

  onDeleteTag(tag: Tag, i: number): void {
    const pill = document.getElementById(tag.title + '_' + i);
    this.model.tags.splice(i, 1);
    this.deleteTag.emit(tag);
    this.checkArrowVisibility(this.tagScrollBody.nativeElement.scrollWidth - pill.clientWidth);
  }
}
